import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Td,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Button,
  Checkbox,
  useBreakpointValue,
  Center,
} from "@chakra-ui/react";
import { FaEllipsisV, FaEye, FaTrash, FaPen } from "react-icons/fa";
import axios from "axios";
import styles from "../Tabel.module.css";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";
const CashTable = () => {
  // Get cmp_id from session storage
  const cmpId = sessionStorage.getItem("cmp_id"); // Fallback to '1' if not found

  const defaultFdate = "2024-04-01";
  const currentDate = new Date().toISOString().split("T")[0];

  const [passbookData, setPassbookData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [fdate, setFdate] = useState(defaultFdate);
  const [tdate, setTdate] = useState(currentDate);
  // const [ctotal, setCtotal] = useState([]);
  // const [dtotal, setDtotal] = useState([]);
  const [companyData, setCompanyData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);

  const fetchPassbookData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${ACCOUNTS_URL}/reports/load_cashbook.php`,
        { fdate, tdate, cmp_id: cmpId, llid: 3 }
      );
      console.log("====================================");
      console.log(response);
      console.log("====================================");
      if (response.data.success) {
        setPassbookData(response.data.cashbookData);
        // setCtotal(response.data.creditTotal || []);
        // setDtotal(response.data.debitTotal || []);
      } else {
        console.error("Failed to fetch passbook data:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching passbook data:", error);
    }
    setLoading(false);
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = Array.isArray(passbookData)
    ? passbookData.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const totalPages = Math.ceil(
    (Array.isArray(passbookData) ? passbookData.length : 0) / rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderRow = (item, index) => {
    const serialNumber = indexOfFirstRow + index + 1;
    return (
      <Tr key={item.vouch_no}>
        <Td py="12px" px="20px" textAlign="center">
          <Checkbox />
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.date.split(" ")[0]}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.voucher_no}
        </Td>
        <Td py="12px" px="20px">
          {item.sho_name}
        </Td>
        <Td py="12px" px="20px">
          {item.group_head}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.debit}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.credit}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.balance}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<FaEllipsisV />}
              size="sm"
              bg="transparent"
            />
            <MenuList boxShadow="none">
              <MenuItem
                icon={<FaEye color="black" style={{ fontSize: "12px" }} />}
              >
                View
              </MenuItem>
              <MenuItem
                icon={<FaPen color="blue" style={{ fontSize: "12px" }} />}
              >
                Edit
              </MenuItem>
              <MenuItem
                icon={<FaTrash color="red" style={{ fontSize: "12px" }} />}
              >
                Delete
              </MenuItem>
            </MenuList>
          </Menu>
        </Td>
      </Tr>
    );
  };

  const handleSubmit = () => {
    if (fdate && tdate) {
      setCurrentPage(1); // Reset to the first page when new data is loaded
      fetchPassbookData();
    }
  };

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      setError("User not logged in or user_id not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const fetchCompanyDetails = async () => {
        try {
          const response = await fetch(
            `${ACCOUNTS_URL}/settings/company_details.php`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ user_id: userId }),
            }
          );

          const data = await response.json();
          console.log("companydetaileseee:", data);

          if (data.status === 200) {
            setCompanyData(data.data);
          } else {
            setError("No company found for this user.");
          }
        } catch (err) {
          setError("Error fetching company details.");
        }
      };

      fetchCompanyDetails();
    }
  }, [userId]); // Run when userId is set

  const printVoucher = () => {
    // Create an iframe element for printing
    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    // Ensure the iframe is not visible
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    // Access the iframe's document for writing content
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`
            <html>
                <head>
                    <title>Print Voucher</title>
                    <style>
                        body { font-family: 'Poppins', sans-serif; margin: 20px; }
                        .header, .footer { text-align: center; font-weight: bold; margin-bottom: 10px; }
                .header h2 { margin: 0; font-size: 24px; }
                .header p { margin: 0; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #0073e6; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        tr:hover { background-color: #ddd; }
                        
                        /* Ensure styles are applied for print */
                        @media print {
                            th { background-color: #0073e6 !important; color: white !important; -webkit-print-color-adjust: exact; }
                            tr:nth-child(even) { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
                            tr:hover { background-color: #ddd !important; -webkit-print-color-adjust: exact; }
                        }
                    </style>
                </head>
                <body>
                <div class="header">
    ${
      companyData?.Company_Name?.startsWith("No") === false
        ? `<h2>${companyData.Company_Name}</h2>`
        : ""
    }

   
    ${
      companyData?.address?.startsWith("No") === false
        ? `<p>${companyData.address}</p>`
        : ""
    }
    ${
      companyData?.Tin?.startsWith("No") === false
        ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
        : ""
    }
    ${
      companyData?.Email_Id?.startsWith("No") === false
        ? `<p>Email: ${companyData.Email_Id}</p>`
        : ""
    }
  
</div>
                    <table>
                        <thead>
                            <tr style="background-color: #0073e6; color: white;">
                                <th style="text-align: center; padding: 12px;">Date</th>
                                <th style="text-align: center; padding: 12px;">Voucher No.</th>
                                <th style="padding: 12px;">Particulars</th>
                                <th style="text-align: center; padding: 12px;">Type</th>
                                <th style="text-align: right; padding: 12px;">Debit</th>
                                <th style="text-align: right; padding: 12px;">Credit</th>
                                <th style="text-align: right; padding: 12px;">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${passbookData
                              .map((item, index) => {
                                const isBold =
                                  item.sho_name_1 === "Opening Balance" ||
                                  item.sho_name_1 === "Current Total";
                                return `
                                    <tr style="font-weight: ${
                                      isBold ? "bold" : "normal"
                                    };">
                                        <td style="padding: 12px 20px; text-align: center;">${
                                          item.date.split(" ")[0]
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: center;">${
                                          item.voucher_no
                                        }</td>
                                        <td style="padding: 12px 20px;">
                                            ${item.sho_name}
                                        </td>
                                        <td style="padding: 12px 20px; text-align: center;">${
                                          item.group_head
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: right;">${
                                          item.debit
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: right;">${
                                          item.credit
                                        }</td>
                                        <td style="padding: 12px 20px; text-align: right;">${
                                          item.balance
                                        }</td>
                                    </tr>
                                `;
                              })
                              .join("")}
                        </tbody>
                    </table>
                </body>
            </html>
        `);
    iframeDoc.close();

    // Print from the iframe and remove it afterward
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  };
  return (
    <Box minH="750px" p={1} width="100%" bg="white">
      <Flex
        borderTopWidth="1px"
        p={3}
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        className="sb"
      >
        {/* Rows Per Page - Left align on mobile */}
        <Flex
          align="center"
          mb={{ base: 4, md: 0 }}
          p={1}
          justify={{ base: "flex-start", md: "center" }}
        >
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            borderColor="#E9EDF4"
          >
            <option value={12}>12</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text ml={2}>Entries</Text>
        </Flex>

        {/* Date Inputs and Submit Button */}
        <Flex
          justify={{ base: "space-between", md: "flex-end" }}
          align="start"
          direction={{ base: "column", md: "row" }}
        >
          <Flex
            direction={{ base: "column", md: "row" }}
            align="flex-start" // Align inputs to the start on mobile
            spacing={4}
            mb={{ base: 4, md: 0 }}
            w={{ base: "100%" }}
          >
            <Input
              type="date"
              placeholder="From Date"
              value={fdate}
              borderColor="#E9EDF4"
              onChange={(e) => setFdate(e.target.value)}
              mb={{ base: 2, md: 0 }} // Margin between date inputs on mobile
              w={{ base: "100%" }}
              mr={{ base: 0, md: 4 }}
            />
            <Input
              type="date"
              placeholder="To Date"
              value={tdate}
              borderColor="#E9EDF4"
              onChange={(e) => setTdate(e.target.value)}
            />
          </Flex>
          <Button
            backgroundColor="teal"
            ml={{ base: 0, md: 4 }}
            color="white"
            w={{ base: "100%" }}
            onClick={handleSubmit}
            alignSelf={{ base: "flex-start", md: "center" }}
          >
            Submit
          </Button>
          <Button
            onClick={printVoucher}
            w={{ base: "100%", md: "auto" }}
            mt={{ base: 2, md: 0 }}
            ml={{ md: 4 }}
            minW={{ md: "70px" }}
          >
            Print{" "}
          </Button>
        </Flex>
      </Flex>

      <Box
        style={{ overflowX: "auto" }}
        w={{ base: "367px", md: "100%" }}
        className={styles.Table}
      >
        {loading ? (
          // <Spinner size="xl" />
          <Center>
            <Text>No Cashbook Entries Found</Text>
          </Center>
        ) : (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            borderWidth="1px"
          >
            <Thead>
              <Tr>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  <Checkbox />
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Date
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Voucher No
                </Th>
                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  Particulars
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Type
                </Th>
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                >
                  Debit
                </Th>
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                >
                  Credit
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Balance
                </Th>
                <Th
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                ></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((item, index) => renderRow(item, index))
              ) : (
                <Tr>
                  <Td colSpan={8} textAlign="center">
                    No Cashbook Entries Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        )}
      </Box>

      {/* <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
                <Tbody>
                    <Tr >
                        <Td py="12px" px="20px" textAlign="right"></Td>
                        <Td py="12px" px="20px" textAlign="right"></Td>
                        <Td py="12px" px="20px" textAlign="right"></Td>
                        <Td py="12px" px="12px" textAlign="right"></Td>
                        <Td py="12px" px="20px" textAlign="left"fontWeight="bold">Current Total</Td>
                      
                        <Td py="12px" px="15px" textAlign="right" fontWeight="bold">{dtotal} Dr</Td>
                        <Td py="12px" px="6px" textAlign="right" fontWeight="bold">{ctotal} Cr</Td>

                    </Tr>
                </Tbody>

            </Table> */}

      {currentData.length > 0 && (
        <Flex justify="end" className="sb2" borderTopWidth="1px" mt={1} p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" mx={2}>
            {currentPage > 1 && (
              <>
                <Button onClick={() => handlePageChange(1)}>1</Button>
                {currentPage > 2 && <Text>...</Text>}
              </>
            )}
            <Button backgroundColor="teal" color="white">
              {currentPage}
            </Button>
            {currentPage < totalPages - 1 && (
              <>
                <Text>...</Text>
                <Button onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Button>
              </>
            )}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      )}
    </Box>
  );
};

export default CashTable;
